import * as type from './types';

export function updateProfileImage(data) {
    return {
        type: type.POST_UPDATE_PROFILE_IMAGE_REQUESTED,
        data: data,
    }
}